/* eslint-disable arrow-body-style */
import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import CommonTable from '@/pages/dashboard/components/CommonTable';
import NewSelectorMultiple from '@/pages/dashboard/components/NewSelectorMultiple';
import { ChangeAnalysisAiSummarySection } from '../ChangeAnalysisAiSummarySection';
import classNames from 'classnames';
import { PAGE_SIZE_OPTIONS } from '@/pages/dashboard/components/CommonTable/config';
import _ from 'lodash-es';
import { sortAdapter } from '@/pages/dashboard/components/CommonTable/utils';
import { dynamicString } from '@home/utils/dynamicString';
import { multiSelectValueAdapter } from './utilts';

export const ChangeAnalysisAbnormalAttributionTable = (props: any) => {
  const { config, className, changeData, commonBaseTableProps, ...restProps } = props;
  const { tableConfig, featConfig, ...restCommonBaseTableProps } = commonBaseTableProps || {};
  const { sort, ...restFeatConfig } = featConfig || {};
  const { pagination, ...restTableConfig } = tableConfig || {};

  const { data } = restProps;
  const { tableData, optionData } = data;

  const [multiSelectValue, setMultiSelectValue] = useState(multiSelectValueAdapter(data?.extraParams?.filters?.dim_list || ['汇总'], 'frontend'));
  const [currentPage, setCurrentPage] = useState(data?.extraParams?.page || 1);
  const [currentPageSize, setCurrentPageSize] = useState(data?.extraParams?.page_size || 10);
  const [currentSort, setCurrentSort] = useState(data?.extraParams?.multi_sort || []);

  const isInitialFilterMount = useRef(true);
  const isInitialPaginationMount = useRef(true);

  const dataSource = tableData?.data?.list || [];
  const columns = restCommonBaseTableProps?.columns || [];

  function generateMetricsAndMap(columns) {
    const metrics = [];
    const metrics_map = {};

    const formatToType = (format) => {
      if (!format) return "";
      if (format.startsWith("percent")) return "percent";
      if (format.includes("thousand")) return "int";
      return "";
    };

    for (const col of columns) {
      const { code, nameEn, nameCn, features } = col;
      if (!code) continue;

      metrics.push(code);

      metrics_map[code] = {
        en: nameEn,
        zh: nameCn,
        type: formatToType(features?.format),
      };
    }

    return { metrics, metrics_map };
  }

  const { metrics, metrics_map } = generateMetricsAndMap(columns);

  useEffect(() => {
    changeData('abnormalAttributionData', {
      metrics,
      metrics_map,
    });
  }, []);

  useEffect(() => {
    if (isInitialFilterMount.current) {
      isInitialFilterMount.current = false;
      return;
    }

    changeData('abnormalAttributionFilter', {
      filters: {
        dim_list: multiSelectValue?.[0] === '255' ? [optionData?.data?.[0]?.dims] : multiSelectValue,
      },
    });
  }, [multiSelectValue]);

  useEffect(() => {
    if (isInitialPaginationMount.current) {
      isInitialPaginationMount.current = false;
      return;
    }
    changeData('extraParams', {
      page_size: currentPageSize,
      page: currentPage,
      /**
       * * 注意区分 - CommonTable 这边使用的 ali-react-table [{ code: string, order: 'desc' | 'asc' | 'none' }]
       * * 注意区分 - SortPopover 那边使用的 [{ by: string, order: 'desc' | 'asc' | 'undefined' }]
       * * 注意区分 - 后端接受的是 [{ sort_by: string, order: boolean }]
      */
      multi_sort: sortAdapter.toBackend(currentSort),
    });
  }, [currentPage, currentPageSize, currentSort]);

  const aiContent = data?.aiData?.data?.content || '';
  const summaryName = optionData?.data?.[0]?.dims || '';
  const formattedOptions = (optionData?.data ?? [])?.slice(1)?.map((item: { dims: string; }) => ({
    value: item.dims,
    text: item.dims,
  }));

  const renderSelector = () => {
    return (
      <div className="dbd-change-analysis__abnormal-attribution-table__content-header">
        {(tableData?.data?.row_count > 0 && aiContent && multiSelectValue?.includes('255')) &&
          <ChangeAnalysisAiSummarySection
            data={dynamicString(restProps.metricsCardWrapProps?.contentHeaderPrefix, data) || ''}
            loading={data?.aiData?.loading}
          />
        }
        {optionData?.data?.length > 1 &&
          <NewSelectorMultiple
            className="dbd-change-analysis__abnormal-attribution-table__content-header__multi-selector"
            allDescribe={summaryName}
            label="Dimension"
            value={multiSelectValue}
            onChange={(value) => {
              setMultiSelectValue(value);
            }}
            options={formattedOptions}
          />
        }
      </div>
    );
  };

  return (
    <CommonTable
      {...restProps}
      className={classNames('dbd-change-analysis__abnormal-attribution-table', className, {
        'dbd-change-analysis__abnormal-attribution-table-loading': tableData?.loading,
      })}
      metricsCardWrapProps={{
        contentHeader: renderSelector(),
        ..._.omit(restProps.metricsCardWrapProps, 'contentHeaderPrefix'),
      }}
      commonBaseTableProps={{
        isLoading: tableData?.loading,
        dataSource,
        featConfig: {
          sort: {
            sorts: sortAdapter.toAli(currentSort),
          },
          ...restFeatConfig,
        },
        tableConfig: {
          onSortChange: (sorts) => {
            setCurrentSort(sorts);
          },
          pagination: {
            total: tableData?.data?.row_count || 0,
            pageIndex: currentPage,
            pageSize: currentPageSize,
            onPageSizeChange: (paginationInfo) => {
              setCurrentPage(paginationInfo.pageIndex);
              setCurrentPageSize(paginationInfo.pageSize);
            },
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            ...pagination,
          },
          ...restTableConfig,
        },
        ...restCommonBaseTableProps,
      }}
    />
  );
};
